import { createReducer, on } from "@ngrx/store";
import * as ownActions from "../../actions";

export interface LayoutState {
    submenu: boolean;
    menu_mobile: boolean;
    loading: boolean;
    setcolor: string;
    urlActive1: string;
    urlActive2: string;
}

export const layoutState: LayoutState = {
    submenu: false,
    menu_mobile: false,
    loading: true,
    setcolor: "",
    urlActive1: "",
    urlActive2: "",
};

const _layoutReducer = createReducer(
    layoutState,
    //  Cambia el estado del Menu Mobile
    on(ownActions.toggleMenuMobile, (state) => ({
        ...state,
        menu_mobile: !state.menu_mobile,
    })),
    //  Asigna los valores de las URL
    on(ownActions.setUrl, (state, { urlActive1, urlActive2 }) => ({
        ...state,
        urlActive1,
        urlActive2
    })),
    //  Cambia el estado del Menu Mobile
    on(ownActions.setLoading, (state, { loading }) => ({
        ...state,
        loading
    })),
    //  Cambia el estado del Submenu
    on(ownActions.setSubMenu, (state, { submenu }) => ({
        ...state,
        submenu,
    })),
    //  Cambia el color del producto
    on(ownActions.setColorProduct, (state, { setcolor }) => ({
        ...state,
        setcolor,
    }))
);

export function layoutReducer(state, action) {
    return _layoutReducer(state, action);
}
